const OfferListTableLangKey = [
	'column_id',
	'column_name',
	'column_affiliate_network',
	'column_country'
] as const

type IOfferListTableLangKey = typeof OfferListTableLangKey[number]

export type IOfferListTableLang = {
	offer_list_table: Record<IOfferListTableLangKey, string>
}

const langEntries = OfferListTableLangKey.map(
	(key: IOfferListTableLangKey) => [key, `offer_list_table.${key}`]
)

const langObj: Record<IOfferListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_LIST_TABLE_LANG_KEY: IOfferListTableLang = {
	offer_list_table: langObj
}